const B_1 = [
    {
        title: '项目管理',
        path: '/bidding/project/list'
    }
]

export default {
    path: '',
    component: () => import(/*webpackChunkName: 'project'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import(/*webpackChunkName: 'project'*/'@views/bidding/views/project/list'),
            meta: {
                title: '项目列表',
                topNav: true,
                bread: B_1
            },
        },{
            path:"detail",
            component: () => import(/*webpackChunkName: 'project'*/'@views/bidding/views/project/detail'),
            meta: {
                title: '项目详情',
                bread: B_1
            },
        },{
            path:"form",
            component: () => import(/*webpackChunkName: 'project'*/'@views/bidding/views/project/form'),
            meta: {
                title: '添加项目',
                bread: B_1
            },
        },{ 
            // 统一项目
            path:"getproinfoForm",
            component: () => import(/*webpackChunkName: 'project'*/'@views/bidding/views/project/getproinfo-form'),
            meta: {
                title: '添加项目',
                bread: B_1
            },
        },{
            path:"getsjjtForm",
            component: () => import(/*webpackChunkName: 'project'*/'@views/bidding/views/project/getsjjt-form'),
            meta: {
                title: '添加项目',
                bread: B_1
            },
        },
    ]
}
